import { render, staticRenderFns } from "./PaymentHubTableResponsive.vue?vue&type=template&id=24d2d7a4&scoped=true"
import script from "./PaymentHubTableResponsive.vue?vue&type=script&lang=js"
export * from "./PaymentHubTableResponsive.vue?vue&type=script&lang=js"
import style0 from "./PaymentHubTableResponsive.vue?vue&type=style&index=0&id=24d2d7a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2d7a4",
  null
  
)

export default component.exports